import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Table, Button, Label, Input } from "reactstrap";
import useFetchClasses from "../../hooks/useFetchClasses";
import useFetchSections from "../../hooks/useFetchSections";
import "./AdmStudentPromotion.css";
import { ApiUrl } from "../../../ApiUrl";
import Select from "react-select";
const StudentPromotion = () => {
  const { classes, loading, error } = useFetchClasses();
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [promotedStudents, setPromotedStudents] = useState([]);
  const [leftSearchQuery, setLeftSearchQuery] = useState("");
  const [rightSearchQuery, setRightSearchQuery] = useState("");
  const [selectedToClass, setSelectedToClass] = useState("");
  const [showTableData, setShowTableData] = useState(false); // Controls when data shows
  const navigate = useNavigate();

  const [selectedToSection, setSelectedToSection] = useState("");
  const {
    sections,
    loading: sectionLoading,
    error: sectionError,
  } = useFetchSections(selectedClass);
  const {
    sections: toSections,
    loading: toSectionLoading,
    error: toSectionError,
  } = useFetchSections(selectedToClass);
  const [students, setStudents] = useState([]);
  const [studentLoading, setStudentLoading] = useState(false);
  const [studentError, setStudentError] = useState("");

  const buildSearchText = (student) => {
    const name = student.student_name || student.studentname || "";
    const admissionNo = student.school_admission_no || "";
    const rollNo = student.rollno !== null && student.rollno !== undefined ? String(student.rollno) : "";
    return `${name} ${admissionNo} ${rollNo}`.toLowerCase();
  };

  const filteredStudents = students.filter((student) =>
    buildSearchText(student).includes(leftSearchQuery.trim().toLowerCase())
  );

  const filteredPromotedStudents = promotedStudents.filter((student) =>
    buildSearchText(student).includes(rightSearchQuery.trim().toLowerCase())
  );

  // const fetchStudents = async () => {
  //   const classId = localStorage.getItem("selectedClassId");
  //   const sectionId = localStorage.getItem("selectedSectionId");
  //   if (!classId || !sectionId) return;
  //   setStudentLoading(true);
  //   try {
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}FILTER/GetstudentBasedClassSection/${classId}/${sectionId}/`
  //     );
  //     const result = await response.json();
  //     if (result.message === "Success") {
  //       setStudents(result.data);
  //     } else {
  //       setStudentError("No data found");
  //     }
  //   } catch (error) {
  //     setStudentError("Error fetching students");
  //   } finally {
  //     setStudentLoading(false);
  //   }
  // };

  useEffect(() => {
    // Cleanup on unmount (when leaving page / refreshing)
    return () => {
      localStorage.removeItem("selectedClassId");
      localStorage.removeItem("selectedSectionId");
      localStorage.removeItem("toClassId");
      localStorage.removeItem("toSectionId");
    };
  }, []);

  useEffect(() => {
    const handleSessionChange = () => {
      //  Clear all fields and data
      setSelectedClass("");
      setSelectedSection("");
      setSelectedToClass("");
      setSelectedToSection("");
      setSelectedStudents([]);
      setPromotedStudents([]);
      setStudents([]);
      setShowTableData(false);

      if (fromClassRef.current) fromClassRef.current.value = "";
      if (fromSectionRef.current) fromSectionRef.current.value = "";
      if (toClassRef.current) toClassRef.current.value = "";
      if (toSectionRef.current) toSectionRef.current.value = "";
    };

    window.addEventListener("academicSessionChanged", handleSessionChange);
    return () =>
      window.removeEventListener("academicSessionChanged", handleSessionChange);
  }, []);

  // const handleClassChange = (e) => {
  //   const classId = e.target.value;
  //   setSelectedClass(classId);
  //   localStorage.setItem("selectedClassId", classId); // Store in local storage
  // };

  const handleClassChange = (e) => {
    const classId = e.target.value;
    setSelectedClass(classId);
    localStorage.setItem("selectedClassId", classId); // Store in local storage

    // 🔄 Clear all dependent dropdowns and data
    setSelectedSection("");
    setSelectedToClass(""); // Clear the "To Class" as well
    setSelectedToSection("");
    setSelectedStudents([]);
    setPromotedStudents([]);
    setStudents([]);

    // 🔄 Optionally clear related localStorage
    localStorage.removeItem("selectedSectionId");
    localStorage.removeItem("selectedToClassId");
    localStorage.removeItem("selectedToSectionId");
    localStorage.removeItem("selectedClassConfirmStudentId");
  };

  const handleSectionChange = (e) => {
    const sectionId = e.target.value;
    setSelectedSection(sectionId);
    localStorage.setItem("selectedSectionId", sectionId); // Store in local storage
  };

  const handleToClassChange = (e) => {
    const classId = e.target.value;
    setSelectedToClass(classId);
  };

  const handleToSectionChange = (e) => {
    const sectionId = e.target.value;
    setSelectedToSection(sectionId);
  };
  const fetchStudents = async () => {
    const academicYearId = localStorage.getItem("academicSessionId");
    const classId = localStorage.getItem("selectedClassId");
    const sectionId = localStorage.getItem("selectedSectionId");

    if (!academicYearId || !classId || !sectionId) {
      setStudentError("Missing required information");
      return;
    }

    setStudentLoading(true);
    try {
      const url = `${ApiUrl.apiurl}FILTER/GetstudentBasedClassSection/?academic_year_id=${academicYearId}&classIds=${classId}&sectionIds=${sectionId}`;
      const response = await fetch(url);
      const result = await response.json();

      if (
        result.message.toLowerCase() === "success" &&
        Array.isArray(result.data)
      ) {
        setStudents(result.data);
        setStudentError(""); // clear error
      } else {
        setStudentError("No data found");
        setStudents([]);
      }
    } catch (error) {
      setStudentError("No student data avilable for this class ");
      setStudents([]);
    } finally {
      setStudentLoading(false);
    }
  };
  const handleDisplayClick = () => {
    setShowTableData(true); // This triggers table to display
    fetchStudents(); // Call API to get student data
  };

  const handleCheckboxChange = (studentId) => {
    if (selectedStudents.includes(studentId)) {
      setSelectedStudents(selectedStudents.filter((id) => id !== studentId));
    } else {
      setSelectedStudents([...selectedStudents, studentId]);
    }
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const allStudentIds = filteredStudents.map((student) => student.student_id);
      setSelectedStudents(allStudentIds);
    } else {
      setSelectedStudents([]);
    }
  };

  const handlePromoteStudents = () => {
    const newPromotedStudents = students.filter((student) =>
      selectedStudents.includes(student.student_id)
    );
    setPromotedStudents((prev) => [...prev, ...newPromotedStudents]);
    setStudents((prev) =>
      prev.filter((student) => !selectedStudents.includes(student.student_id))
    );
    setSelectedStudents([]);
  };

  const handleDemoteStudents = () => {
    const demotedStudents = promotedStudents.filter((student) =>
      selectedStudents.includes(student.student_id)
    );
    setPromotedStudents((prev) =>
      prev.filter((student) => !selectedStudents.includes(student.student_id))
    );
    setStudents((prev) => [...prev, ...demotedStudents]);
    setSelectedStudents([]);
  };

  const handleSelectAllPromoted = (event) => {
    if (event.target.checked) {
      const allPromotedIds = filteredPromotedStudents.map(
        (student) => student.student_id
      );
      setSelectedStudents(allPromotedIds);
    } else {
      setSelectedStudents([]);
    }
  };

  const resolveNextAcademicSessionId = async (currentSessionId) => {
    if (!currentSessionId) return "";

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}AcademicYear/GetAllAcademicYear/`
      );
      const result = await response.json();

      if (String(result?.message || "").toLowerCase() !== "success") {
        return "";
      }

      const years = (result?.data || [])
        .map((year) => ({
          id: year.id,
          dateFrom: new Date(year.date_from),
        }))
        .sort((a, b) => a.dateFrom - b.dateFrom);

      const currentIndex = years.findIndex(
        (year) => String(year.id) === String(currentSessionId)
      );

      if (currentIndex === -1) return "";

      const nextYear = years[currentIndex + 1];
      return nextYear ? String(nextYear.id) : "";
    } catch (error) {
      console.error("Error resolving next academic session:", error);
      return "";
    }
  };

  const updateStudentStatus = async (status) => {
    const classId = localStorage.getItem("toClassId");
    const sectionId = localStorage.getItem("toSectionId");
    const academicSessionId = localStorage.getItem("academicSessionId");
    let nextAcademicSessionId = localStorage.getItem("nextAcademicSessionId");
    const userId = sessionStorage.getItem("userId");

    if (
      !nextAcademicSessionId ||
      nextAcademicSessionId === "null" ||
      String(nextAcademicSessionId) === String(academicSessionId)
    ) {
      const resolvedNextSessionId = await resolveNextAcademicSessionId(
        academicSessionId
      );
      if (resolvedNextSessionId) {
        nextAcademicSessionId = resolvedNextSessionId;
        localStorage.setItem("nextAcademicSessionId", resolvedNextSessionId);
      }
    }

    //  Check if future session ID is missing
    if (
      !nextAcademicSessionId ||
      nextAcademicSessionId === "null" ||
      String(academicSessionId) === String(nextAcademicSessionId)
    ) {
      alert("Future session is not created yet.");
      return;
    }

    const promotedStudentIds = promotedStudents.map((student) => student.student_id);
    const sourceStudentIds =
      promotedStudentIds.length > 0
        ? promotedStudentIds
        : students
            .filter((student) => selectedStudents.includes(student.student_id))
            .map((student) => student.student_id);

    const studentIds = [...new Set(sourceStudentIds)];
    if (studentIds.length === 0) {
      alert("No students to update.");
      return;
    }

    const payload = {
      classId: parseInt(classId),
      sectionId: parseInt(sectionId),
      academicyearId: parseInt(academicSessionId),
      NextacademicyearId: parseInt(nextAcademicSessionId),
      studentId: studentIds,
      studentStatus: status,
      created_by: parseInt(userId),
    };

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}STUDENTPROMOTION/studentclasspromotion/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      console.log("API Response:", result);

      let successMessage = "";
      if (status === "promoted") {
        successMessage = "Promotion successful!";
      } else if (status === "Fail") {
        successMessage = "Marked as Failed!";
      } else if (status === "demoted") {
        successMessage = "Demotion successful!";
      }

      const apiMessage = String(result?.message || "").toLowerCase();
      if (response.ok && apiMessage.includes("successfully")) {
        alert(successMessage);
        setPromotedStudents([]);
        setSelectedStudents([]);
        setStudents((prev) =>
          prev.filter((student) => !studentIds.includes(student.student_id))
        );
      } else {
        const errorMessage =
          result?.error?.non_field_errors?.[0] ||
          result?.error ||
          result?.message ||
          "Failed to update student status.";
        alert(errorMessage);
      }
    } catch (error) {
      alert("Error updating student status");
      console.error("Error:", error);
    }
  };

  const fromClassRef = useRef();
  const fromSectionRef = useRef();
  const toClassRef = useRef();
  const toSectionRef = useRef();

  // const handleClear = () => {
  //   setSelectedClass("");
  //   setSelectedSection("");
  //   setSelectedToClass("");
  //   setSelectedToSection("");
  //   setSelectedStudents([]);
  //   setPromotedStudents([]);
  //   setStudents([]);
  //   fromClassRef.current.value = "";
  //   fromSectionRef.current.value = "";
  //   toClassRef.current.value = "";
  //   toSectionRef.current.value = "";
  // };
  const handleClear = () => {
    setSelectedClass("");
    setSelectedSection("");
    setSelectedToClass("");
    setSelectedToSection("");
    setSelectedStudents([]);
    setPromotedStudents([]);
    setStudents([]);
    fromClassRef.current.value = "";
    fromSectionRef.current.value = "";
    toClassRef.current.value = "";
    toSectionRef.current.value = "";
    localStorage.removeItem("selectedClassId");
    localStorage.removeItem("selectedSectionId");
    localStorage.removeItem("toClassId");
    localStorage.removeItem("toSectionId");
    setShowTableData(false);
  };
  const handleNewClick = () => {
    navigate("/admin/dashboard");
  };
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT PROMOTION
              </p>
              <Row className="mb-3 mx-2">
                {/* FROM DETAILS */}
                <Col md={6} className="mb-3">
                  <div
                    className="card h-100 shadow-sm"
                    style={{
                      border: "1px solid #d9d9d9",
                      borderRadius: "8px",
                    }}
                  >
                    <div className="card-header text-center fw-bold custom-section-box">
                      FROM DETAILS
                    </div>

                    <div className="card-body custom-section-box">
                      <div className="mb-3 ">
                        <Label>From Class</Label>

                        <Select
                          inputId="from-class"
                          className="detail"
                          classNamePrefix="react-select"
                          options={classes.map((classItem) => ({
                            value: classItem.id,
                            label: classItem.classname,
                          }))}
                          value={
                            selectedClass
                              ? {
                                  value: selectedClass,
                                  label:
                                    classes.find((c) => c.id === selectedClass)
                                      ?.classname || "",
                                }
                              : null
                          }
                          onChange={(selectedOption) =>
                            handleClassChange({
                              target: {
                                value: selectedOption?.value || "",
                              },
                            })
                          }
                          placeholder="Select Class"
                        />
                      </div>

                      <div>
                        <Label>From Section</Label>

                        <Select
                          inputId="from-section"
                          className="detail"
                          classNamePrefix="react-select"
                          options={sections.map((section) => ({
                            value: section.section_id,
                            label: section.sectionname,
                          }))}
                          value={
                            selectedSection
                              ? {
                                  value: selectedSection,
                                  label:
                                    sections.find(
                                      (s) => s.section_id === selectedSection,
                                    )?.sectionname || "",
                                }
                              : null
                          }
                          onChange={(selectedOption) =>
                            handleSectionChange({
                              target: {
                                value: selectedOption?.value || "",
                              },
                            })
                          }
                          placeholder="Select Section"
                        />
                      </div>
                    </div>
                  </div>
                </Col>

                {/* TO DETAILS */}

                <Col md={6} className="mb-3">
                  <div
                    className="card h-100 shadow-sm"
                    style={{
                      border: "1px solid #d9d9d9",
                      borderRadius: "8px",
                    }}
                  >
                    <div className="card-header text-center fw-bold custom-section-box">
                      TO DETAILS
                    </div>

                    <div className="card-body custom-section-box">
                      <div className="mb-3">
                        <Label>To Class</Label>

                        <Select
                          inputId="to-class"
                          className="detail"
                          classNamePrefix="react-select"
                          options={
                            selectedClass
                              ? classes
                                  .filter(
                                    (classItem) =>
                                      classes.indexOf(
                                        classes.find(
                                          (c) => c.id === selectedClass
                                        )
                                      ) < classes.indexOf(classItem)
                                  )
                                  .map((classItem) => ({
                                    value: classItem.id,
                                    label: classItem.classname,
                                  }))
                              : classes.map((classItem) => ({
                                  value: classItem.id,
                                  label: classItem.classname,
                                }))
                          }
                          value={
                            selectedToClass
                              ? {
                                  value: selectedToClass,
                                  label:
                                    classes.find(
                                      (c) => c.id === selectedToClass,
                                    )?.classname || "",
                                }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const selectedClass = selectedOption?.value || "";
                            setSelectedToClass(selectedClass);
                            localStorage.setItem("toClassId", selectedClass);
                          }}
                          placeholder="Select Class"
                        />
                      </div>

                      <div>
                        <Label>To Section</Label>

                        <Select
                          inputId="to-section"
                          className="detail"
                          classNamePrefix="react-select"
                          options={toSections.map((section) => ({
                            value: section.section_id,
                            label: section.sectionname,
                          }))}
                          value={
                            selectedToSection
                              ? {
                                  value: selectedToSection,
                                  label:
                                    toSections.find(
                                      (s) => s.section_id === selectedToSection,
                                    )?.sectionname || "",
                                }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const selectedSection = selectedOption?.value || "";
                            setSelectedToSection(selectedSection);
                            localStorage.setItem(
                              "toSectionId",
                              selectedSection,
                            );
                          }}
                          placeholder="Select Section"
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="mx-2" style={{ border: "1px solid #ccc" }}>
                <Col xs={12} md={5} className="mb-3 mt-3  ">
                  <Input
                    type="text"
                    placeholder="Search students..."
                    className="mb-2"
                    value={leftSearchQuery}
                    onChange={(e) => setLeftSearchQuery(e.target.value)}
                  />
                  <div
                    style={{
                      maxHeight: "340px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <div className="row">
                      <div className="col-12">
                        <div className="table-responsive">
                          <table className="table table-bordered table-hover">
                            <thead>
                              <tr>
                                <th>
                                  <Input
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={
                                      filteredStudents.length > 0 &&
                                      selectedStudents.length ===
                                        filteredStudents.length
                                    }
                                  />
                                </th>
                                <th>Roll No.</th>
                                <th>School Admission No</th>
                                <th>Name</th>
                              </tr>
                            </thead>
                            <tbody>
                              {showTableData ? (
                                studentLoading ? (
                                  <tr>
                                    <td
                                      colSpan="4"
                                      style={{ textAlign: "center" }}
                                    >
                                      Loading students...
                                    </td>
                                  </tr>
                                ) : studentError ? (
                                  <tr>
                                    <td
                                      colSpan="4"
                                      style={{ textAlign: "center" }}
                                    >
                                      {studentError}
                                    </td>
                                  </tr>
                                ) : filteredStudents.length > 0 ? (
                                  filteredStudents.map((student) => (
                                    <tr key={student.student_id}>
                                      <td>
                                        <Input
                                          type="checkbox"
                                          checked={selectedStudents.includes(
                                            student.student_id,
                                          )}
                                          onChange={() =>
                                            handleCheckboxChange(
                                              student.student_id,
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        {student.rollno !== null
                                          ? student.rollno
                                          : "N/A"}
                                      </td>
                                      <td>{student.school_admission_no}</td>
                                      <td>{student.student_name}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="4"
                                      style={{ textAlign: "center" }}
                                    >
                                      No students available for promotion.
                                    </td>
                                  </tr>
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan="4"
                                    style={{ textAlign: "center" }}
                                  >
                                    Click 'Display' to load students.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                {/* <Col
                  xs={12}
                  md={2}
                  className="text-center d-flex flex-column justify-content-center align-items-center mb-3 mt-3"
                >
                  <div className="mb-0">
                    <Button
                      color="primary"
                      className="mb-2 w-100"
                      onClick={handleDisplayClick}
                    >
                      Display
                    </Button>

                    <Button
                      color="primary"
                      className="mb-2 w-100"
                      onClick={handlePromoteStudents}
                    >
                      {" > "}
                    </Button>
                    <Button
                      color="primary"
                      className="mb-2 w-100"
                      onClick={handleDemoteStudents}
                    >
                      {" < "}
                    </Button>
                    <Button
                      color="primary"
                      className="mb-2 w-100"
                      onClick={() => updateStudentStatus("promoted")}
                      disabled={!selectedToClass || !selectedToSection}
                    >
                      Promotion
                    </Button>

                    <Button
                      color="primary"
                      className="mb-2 w-100"
                      onClick={() => updateStudentStatus("Fail")}
                      disabled={!selectedToClass || !selectedToSection}
                    >
                      Failed
                    </Button>

                    <Button
                      color="primary"
                      className="mb-2 w-100"
                      onClick={() => updateStudentStatus("demoted")}
                      disabled={!selectedToClass || !selectedToSection}
                    >
                      Demotion
                    </Button>
                    <Button
                      color="warning"
                      onClick={handleClear}
                      className="mb-2 w-100"
                    >
                      Clear
                    </Button>
                    <Button
                      color="danger"
                      className="mb-2 w-100"
                      onClick={handleNewClick}
                    >
                      Close
                    </Button>
                  </div>
                </Col> */}
                <Col
                  xs={10}
                  md={2}
                  className="d-flex justify-content-center align-items-center mb-3 mt-3 mx-auto"
                >
                  <div
                    className="d-flex flex-column align-items-center"
                    style={{ minWidth: "140px", width: "100%" }}
                  >
                    <Button
                      color="primary"
                      className="mb-2 w-100"
                      onClick={handleDisplayClick}
                    >
                      Display
                    </Button>
                    <Button
                      color="primary"
                      className="mb-2 w-100"
                      onClick={handlePromoteStudents}
                    >
                      {" > "}
                    </Button>
                    <Button
                      color="primary"
                      className="mb-2 w-100"
                      onClick={handleDemoteStudents}
                    >
                      {" < "}
                    </Button>
                    <Button
                      color="primary"
                      className="mb-2 w-100"
                      onClick={() => updateStudentStatus("promoted")}
                      disabled={!selectedToClass || !selectedToSection}
                    >
                      Promotion
                    </Button>
                    <Button
                      color="primary"
                      className="mb-2 w-100"
                      onClick={() => updateStudentStatus("Fail")}
                      disabled={!selectedToClass || !selectedToSection}
                    >
                      Failed
                    </Button>
                    <Button
                      color="primary"
                      className="mb-2 w-100"
                      onClick={() => updateStudentStatus("demoted")}
                      disabled={!selectedToClass || !selectedToSection}
                    >
                      Demotion
                    </Button>
                    <Button
                      color="warning"
                      onClick={handleClear}
                      className="mb-2 w-100"
                    >
                      Clear
                    </Button>
                    <Button
                      color="danger"
                      className="mb-2 w-100"
                      onClick={handleNewClick}
                    >
                      Close
                    </Button>
                  </div>
                </Col>

                <Col xs={12} md={5} className="mt-3">
                  <Input
                    type="text"
                    placeholder="Search promoted students..."
                    className="mb-2"
                    value={rightSearchQuery}
                    onChange={(e) => setRightSearchQuery(e.target.value)}
                  />
                  <div
                    style={{
                      maxHeight: "340px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <div className="row">
                      <div className="col-12">
                        <div className="table-responsive">
                          <table className="table table-bordered ">
                            <thead>
                              <tr>
                                <th>
                                  <Input
                                    type="checkbox"
                                    onChange={handleSelectAllPromoted}
                                    checked={
                                      selectedStudents.length ===
                                        filteredPromotedStudents.length &&
                                      filteredPromotedStudents.length > 0
                                    }
                                  />
                                </th>
                                <th>Roll No.</th>
                                <th>School Admission No</th>
                                <th>Name</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredPromotedStudents.length > 0 ? (
                                filteredPromotedStudents.map((student) => (
                                  <tr key={student.student_id}>
                                    <td>
                                      <Input
                                        type="checkbox"
                                        checked={selectedStudents.includes(
                                          student.student_id,
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            student.student_id,
                                          )
                                        } // Ensure this function is working properly
                                      />
                                    </td>
                                    <td>
                                      {student.rollno !== null
                                        ? student.rollno
                                        : "N/A"}
                                    </td>
                                    <td>{student.school_admission_no}</td>
                                    <td>{student.student_name}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="5">
                                    No students available for promotion.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentPromotion;
